var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"external-link",attrs:{"href":`tel:${_vm.phone.replace(/[^\d+]+/g, '')}`,"color":"primary","x-large":"","depressed":"","block":""}},[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.icons.mdiPhone))]),_c('v-spacer'),_c('div',[_vm._v(_vm._s(_vm.phone))]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }